import React, { useState, useEffect, useContext, useRef } from "react";
import { generatePath, useHistory } from "react-router-dom";
import { Carousel } from 'react-bootstrap'; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import 'swiper/swiper.min.css';
import Swal from 'sweetalert2';
import axios from "axios";
import { withRouter } from "react-router-dom";
import Cookies from 'universal-cookie';
import {FormattedMessage, useIntl} from 'react-intl';
import { scrollToTop, translateTerm } from "../util/helper";
import LeaseSingle from "./lessee/leasesingle";
import { RouteContext } from "../contexts/route.context";
import { useIntersection } from "../util/useIntersection";
import OneSignal from "react-onesignal";

const Home = () => {
  const intl = useIntl();
  const history = useHistory();
  const cookies = new Cookies();
  const { baseURL, apiHeaders, getMe, me, getPosts, posts, postsLoading, setPostsLoading,
    getUserPosts, userPosts, userPostsLoading, setUserPostsLoading, } = useContext(RouteContext);
  const ref = useRef(null);
  const [bannerIndex, setBannerIndex] = useState(0);
  const [serIndex, setSerIndex] = useState(0);
  const [numLease, setNumLease] = useState(12);
  const [pageLease, setpageLease] = useState(1);

  const [userProducts, setUserProducts] = useState();
  const [productsLoading, setProductsLoading] = useState(false);

  const [moreLoading, setMoreLoading] = useState(false);
  const [noMorePosts, setNoMorePosts] = useState(false);
  const elementRef = useRef(null);
  const isVisible = useIntersection(elementRef, "0px 0px 40% 0px");
  const [toTop, setToTop] = useState(true);

  useEffect(() => {
    setPostsLoading(true);
    setUserPostsLoading(true);
    // let inp = `{featured_post: true}`;
    // getPosts(numLease, pageLease, inp);
    
    getMe();
    window.scrollTo(0, 0);

  }, []);

  useEffect(()=>{
    if(me?.role.id === 3){
      let inp = `{user_id: "${me.id}"}`;
      getUserPosts(numLease, pageLease, inp);
    }

  },[me])


  const registerOneSignal = async (id) => {
    let loginResult = await OneSignal.login(id).catch((error) => {
        console.error("OneSignal login error: ", error);
      });

    let addTagResult = OneSignal?.User?.addTags(
    {
    userId: `userId_${id}`,
    platform: "web"
    }
    )
  }

  const handleSelectBanner = (selectedIndex, e) => {
    setBannerIndex(selectedIndex);
  };
  
  const handleSelectSer = (selectedIndex, e) => {
    setSerIndex(selectedIndex);
  };

  const onPrevClick = () => {
    ref.current.prev();
  };
  const onNextClick = () => {
    ref.current.next();
  };

  const onClickPost = (id) => {
    scrollToTop(0);
    id && history.push(generatePath("/lease/:id", { id }));
  }

  useEffect(() => {
    // if(me?.name === null){
    //   if(me?.role.id === "3"){
    //     window.location.href = "/step3-lessor";
    //   }
    //   else{
    //     window.location.href = "/step3-lessee";
    //   }
    // }
    // else{
      if(me) {
        let inp = `{user_id: "${me.id}"}`;
        // getUserPosts(numLease, pageLease, inp);
      readUserPosts(inp)
      registerOneSignal(me?.id)
      }
      window.scrollTo(0, 0);
    // }
  }, [me]);

  useEffect(() => {
      if (isVisible && me) {
      // Trigger a function when the div is visible on view port
      triggerFunc();
      }
    }, [isVisible]);

  const triggerFunc = () => {
    let inp = `{user_id: "${me.id}"}`;
    if(userProducts){
        if(userProducts.paginatorInfo.hasMorePages){
            scrollPosts(inp);
        }
        else{
            setNoMorePosts(true);
        }
    }
  }

  useEffect(()=>{
    if(userProducts){
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll)
        };
    }
  },[userProducts]);

  const handleScroll = () => {
    if(!toTop && userProducts){
        if(Math.ceil(window.innerHeight  + document.documentElement.scrollTop) > document.documentElement.offsetHeight * 0.80){
            setToTop(true);
        }
    }
  };

  const setMeToTop = () => {
    scrollToTop(0);
}

  const scrollPosts = async (inp) => {
    if(moreLoading == false){
      setMoreLoading(true);
      let result = await getUserPosts(numLease, userProducts.paginatorInfo.currentPage+1, inp);
      if(userProducts.paginatorInfo.hasMorePages){
          result.data.map((dat)=>{
            userProducts.data.push(dat);
          })
          userProducts.paginatorInfo = result.paginatorInfo;
          setToTop(true);
      }
      setMoreLoading(false);
    }
    return true;
  }


//   const handleScroll = async () => {
//       let inp = `{user_id: "${me.id}"}`;
//       if(userProducts){
//         if (Math.ceil(window.innerHeight  + document.documentElement.scrollTop) === document.documentElement.offsetHeight ) {
//           if(userProducts.paginatorInfo.hasMorePages){
//             scrollPosts(inp);
//             }
//           }
//         }
// };

  const readUserPosts = async (inp) => {
    if(productsLoading===false){
      setProductsLoading(true);
      let result = await getUserPosts(numLease, pageLease, inp);
      setUserProducts(result);
    }
    setProductsLoading(false);
    
  }


  // for my post lessor


  const onDeletePost = (post) => {

    Swal.fire({
      title: 'Do you want to delete post?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Delete',
      confirmButtonColor: '#25D676',
      denyButtonText: `Don't delete`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUserPostsLoading(true);
        
        let result = await axios({
          url: baseURL,
          headers: apiHeaders,
          method: "post",
          data: {
            query: `
              mutation {
                deletePost(id: ${post.id}){
                  id
                  message
                  status
                }
              }
            `
          }
        });
    
        if(result.data.data) {
          Swal.fire({
            title: 'Deleted a Post',
            text: "",
            icon: 'success',
            confirmButtonColor: '#FF5833',
          }).then((e) => {
            setUserPostsLoading(false);
            getUserPosts(numLease, pageLease);
          });
        }
        else {

          Swal.fire({
            title: 'Delete Post Failed',
            text: result.data.errors[0].message,
            icon: 'warning',
            confirmButtonColor: '#CF3202',
          }).then((e) => {
            // setUserPostsLoading(false);
            // getUserPosts(numLease, pageLease);
            window.location.reload();
          });

        }

      }
    });
  }

  
  const onGenerateQr = (post) => {
    let id = post.id;
    // cookies.set('qr_post_id', post.id);
    history.push(generatePath("/new-qr/product/:id", {id}))

  }

  const onEditPost = (post) => {
    cookies.set('edit_post_id', post.id);
    // window.location.href = "/add-post";
    history.push("/edit-post");
  }

  const onClickAddPost = () => {
    // window.location.href = "/add-post";
    history.push("/add-post");
  }

  return (
    <div>
      {/* display banner to all except lessor user */}
      {me ? me.role.id != 3 && (
        <div className="container-fluid banner-div">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
              <div className="banner-text-div">
                <div>
                  <h1 className="fw600 cwhite title mb-4">
                    <FormattedMessage 
                      id="rentdonefinal.text"
                      defaultMessage="Renting Process Made Easy"
                      description="Renting Process Made Easy"
                    />
                  </h1>
                  <p className="fw500 cwhite fs18 text">
                    <FormattedMessage 
                      id="rentdonefinaldesc.text"
                      defaultMessage="Renting Done Right. Finally."
                      description="Renting Done Right. Finally. description"
                    />
                  </p>
                  <a href="/leases" className="btn btn-orang-def">
                    <FormattedMessage 
                      id="rentnow.text"
                      defaultMessage="Rent Now"
                      description="Rent Now"
                    />
                  </a>
                </div>
              </div>

            </div>
            <div className="col-12 col-md-6 col-lg-6 banner-img-slide-div">
              <Carousel 
                ref={ref} 
                controls={false} 
                indicators={false} 
                activeIndex={bannerIndex} 
                onSelect={handleSelectBanner}
              >
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Devices & Appliances2.png"
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Properties2.png"
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Tools & Equipment2.png"
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Cars & Vehicles2.png"
                    alt="Second slide"
                  />
                </Carousel.Item>
              </Carousel>
              {/* <div className="carousel-custombtn-div banner">
                <button className="btn btn-back" onClick={onPrevClick}>
                  <svg width="20" height="20" style={{marginTop:"2px"}}  viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.64805 17.0484C9.42301 17.2734 9.11784 17.3997 8.79965 17.3997C8.48145 17.3997 8.17628 17.2734 7.95125 17.0484L0.751246 9.8484C0.526281 9.62337 0.399902 9.3182 0.399902 9C0.399902 8.6818 0.526281 8.37663 0.751246 8.1516L7.95125 0.9516C8.17757 0.733011 8.48069 0.612057 8.79533 0.614791C9.10996 0.617526 9.41094 0.743728 9.63343 0.966218C9.85592 1.18871 9.98212 1.48968 9.98485 1.80432C9.98759 2.11895 9.86664 2.42208 9.64805 2.6484L4.49645 7.8H18.3996C18.7179 7.8 19.0231 7.92643 19.2482 8.15147C19.4732 8.37652 19.5996 8.68174 19.5996 9C19.5996 9.31826 19.4732 9.62348 19.2482 9.84853C19.0231 10.0736 18.7179 10.2 18.3996 10.2H4.49645L9.64805 15.3516C9.87301 15.5766 9.99939 15.8818 9.99939 16.2C9.99939 16.5182 9.87301 16.8234 9.64805 17.0484Z" fill="#242424"/>
                  </svg>
                  <FormattedMessage 
                    id="back.text"
                    defaultMessage="Back"
                    description="Back"
                  />
                </button>
                <button className="btn btn-next" onClick={onNextClick}>
                  <FormattedMessage 
                    id="next.text"
                    defaultMessage="Next"
                    description="Next"
                  />
                  <svg width="20" height="20" style={{marginTop:"2px"}} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M10.8515 0.951685C11.0765 0.72672 11.3817 0.600342 11.6999 0.600342C12.0181 0.600342 12.3233 0.72672 12.5483 0.951685L19.7483 8.15169C19.9733 8.37672 20.0996 8.68189 20.0996 9.00009C20.0996 9.31828 19.9733 9.62345 19.7483 9.84849L12.5483 17.0485C12.322 17.2671 12.0189 17.388 11.7042 17.3853C11.3896 17.3826 11.0886 17.2564 10.8661 17.0339C10.6436 16.8114 10.5174 16.5104 10.5147 16.1958C10.512 15.8811 10.6329 15.578 10.8515 15.3517L16.0031 10.2001H2.0999C1.78164 10.2001 1.47642 10.0737 1.25137 9.84861C1.02633 9.62357 0.899902 9.31835 0.899902 9.00009C0.899902 8.68183 1.02633 8.3766 1.25137 8.15156C1.47642 7.92651 1.78164 7.80009 2.0999 7.80009H16.0031L10.8515 2.64849C10.6265 2.42345 10.5002 2.11828 10.5002 1.80009C10.5002 1.48189 10.6265 1.17672 10.8515 0.951685Z" fill="white"/>
                  </svg>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      ) : // show when no user login
      (
        <div className="container-fluid banner-div">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">

              <div className="banner-text-div">
                <div>
                  <h1 className="fw600 cwhite title mb-4">
                    <FormattedMessage 
                      id="rentdonefinal.text"
                      defaultMessage="Renting Process Is Made Easy"
                      description="Renting Process Is Made Easy"
                    />
                  </h1>
                  <p className="fw500 cwhite fs18 text">
                    <FormattedMessage 
                      id="rentdonefinaldesc.text"
                      defaultMessage="Renting Done Right. Finally."
                      description="Renting Done Right. Finally. description"
                    />
                  </p>
                  <a href="/leases" className="btn btn-orang-def">
                    <FormattedMessage 
                      id="rentnow.text"
                      defaultMessage="Rent Now"
                      description="Rent Now"
                    />
                  </a>
                </div>
              </div>

            </div>
            <div className="col-12 col-md-6 col-lg-6 banner-img-slide-div">
              <Carousel 
                ref={ref} 
                controls={false} 
                indicators={false} 
                activeIndex={bannerIndex} 
                onSelect={handleSelectBanner}
              >
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Devices & Appliances2.png"
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Properties2.png"
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Tools & Equipment2.png"
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="assets/images/Cars & Vehicles2.png"
                    alt="Second slide"
                  />
                </Carousel.Item>
              </Carousel>
              {/* <div className="carousel-custombtn-div banner">
                <button className="btn btn-back" onClick={onPrevClick}>
                  <svg width="20" height="18" style={{marginRight:"10px", marginTop:"2px"}} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.64805 17.0484C9.42301 17.2734 9.11784 17.3997 8.79965 17.3997C8.48145 17.3997 8.17628 17.2734 7.95125 17.0484L0.751246 9.8484C0.526281 9.62337 0.399902 9.3182 0.399902 9C0.399902 8.6818 0.526281 8.37663 0.751246 8.1516L7.95125 0.9516C8.17757 0.733011 8.48069 0.612057 8.79533 0.614791C9.10996 0.617526 9.41094 0.743728 9.63343 0.966218C9.85592 1.18871 9.98212 1.48968 9.98485 1.80432C9.98759 2.11895 9.86664 2.42208 9.64805 2.6484L4.49645 7.8H18.3996C18.7179 7.8 19.0231 7.92643 19.2482 8.15147C19.4732 8.37652 19.5996 8.68174 19.5996 9C19.5996 9.31826 19.4732 9.62348 19.2482 9.84853C19.0231 10.0736 18.7179 10.2 18.3996 10.2H4.49645L9.64805 15.3516C9.87301 15.5766 9.99939 15.8818 9.99939 16.2C9.99939 16.5182 9.87301 16.8234 9.64805 17.0484Z" fill="#242424"/>
                  </svg>
                  <FormattedMessage 
                    id="back.text"
                    defaultMessage="Back"
                    description="Back"
                  />
                </button>
                <button className="btn btn-next" onClick={onNextClick}>
                  <FormattedMessage 
                    id="next.text"
                    defaultMessage="Next"
                    description="Next"
                  />
                  <svg width="21" height="18" style={{marginLeft:"10px", marginTop:"2px"}} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M10.8515 0.951685C11.0765 0.72672 11.3817 0.600342 11.6999 0.600342C12.0181 0.600342 12.3233 0.72672 12.5483 0.951685L19.7483 8.15169C19.9733 8.37672 20.0996 8.68189 20.0996 9.00009C20.0996 9.31828 19.9733 9.62345 19.7483 9.84849L12.5483 17.0485C12.322 17.2671 12.0189 17.388 11.7042 17.3853C11.3896 17.3826 11.0886 17.2564 10.8661 17.0339C10.6436 16.8114 10.5174 16.5104 10.5147 16.1958C10.512 15.8811 10.6329 15.578 10.8515 15.3517L16.0031 10.2001H2.0999C1.78164 10.2001 1.47642 10.0737 1.25137 9.84861C1.02633 9.62357 0.899902 9.31835 0.899902 9.00009C0.899902 8.68183 1.02633 8.3766 1.25137 8.15156C1.47642 7.92651 1.78164 7.80009 2.0999 7.80009H16.0031L10.8515 2.64849C10.6265 2.42345 10.5002 2.11828 10.5002 1.80009C10.5002 1.48189 10.6265 1.17672 10.8515 0.951685Z" fill="white"/>
                  </svg>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
      


      {/* <div className="container main-wrap services-main-div">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-5">

            <Carousel 
              ref={ref2} 
              controls={false} 
              indicators={false}
              activeIndex={serIndex} 
              onSelect={handleSelectSer}
            >
              <Carousel.Item>
                <h3 className="mb-3 fw700 cblack ">We provide <br/> Awesome Services</h3>
                <p className="mb-0 fw500 cgray">Maecenas faucibus non libero a rutrum.</p>
              </Carousel.Item>
              <Carousel.Item>
                <h3 className="mb-3 fw700 cblack ">We provide <br/> Awesome Services</h3>
                <p className="mb-0 fw500 cgray">Maecenas faucibus non libero a rutrum.sssssssssssssss</p>
              </Carousel.Item>
            </Carousel>
            <div className="carousel-custombtn-div ser">
              <button className="btn btn-back" onClick={onPrevClick2}>
                <svg width="20" height="18" style={{marginRight:"10px", marginTop:"2px"}} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M9.64805 17.0484C9.42301 17.2734 9.11784 17.3997 8.79965 17.3997C8.48145 17.3997 8.17628 17.2734 7.95125 17.0484L0.751246 9.8484C0.526281 9.62337 0.399902 9.3182 0.399902 9C0.399902 8.6818 0.526281 8.37663 0.751246 8.1516L7.95125 0.9516C8.17757 0.733011 8.48069 0.612057 8.79533 0.614791C9.10996 0.617526 9.41094 0.743728 9.63343 0.966218C9.85592 1.18871 9.98212 1.48968 9.98485 1.80432C9.98759 2.11895 9.86664 2.42208 9.64805 2.6484L4.49645 7.8H18.3996C18.7179 7.8 19.0231 7.92643 19.2482 8.15147C19.4732 8.37652 19.5996 8.68174 19.5996 9C19.5996 9.31826 19.4732 9.62348 19.2482 9.84853C19.0231 10.0736 18.7179 10.2 18.3996 10.2H4.49645L9.64805 15.3516C9.87301 15.5766 9.99939 15.8818 9.99939 16.2C9.99939 16.5182 9.87301 16.8234 9.64805 17.0484Z" fill="#242424"/>
                </svg>
                Back
              </button>
              <button className="btn btn-next" onClick={onNextClick2}>
                Next
                <svg width="21" height="18" style={{marginLeft:"10px", marginTop:"2px"}} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.8515 0.951685C11.0765 0.72672 11.3817 0.600342 11.6999 0.600342C12.0181 0.600342 12.3233 0.72672 12.5483 0.951685L19.7483 8.15169C19.9733 8.37672 20.0996 8.68189 20.0996 9.00009C20.0996 9.31828 19.9733 9.62345 19.7483 9.84849L12.5483 17.0485C12.322 17.2671 12.0189 17.388 11.7042 17.3853C11.3896 17.3826 11.0886 17.2564 10.8661 17.0339C10.6436 16.8114 10.5174 16.5104 10.5147 16.1958C10.512 15.8811 10.6329 15.578 10.8515 15.3517L16.0031 10.2001H2.0999C1.78164 10.2001 1.47642 10.0737 1.25137 9.84861C1.02633 9.62357 0.899902 9.31835 0.899902 9.00009C0.899902 8.68183 1.02633 8.3766 1.25137 8.15156C1.47642 7.92651 1.78164 7.80009 2.0999 7.80009H16.0031L10.8515 2.64849C10.6265 2.42345 10.5002 2.11828 10.5002 1.80009C10.5002 1.48189 10.6265 1.17672 10.8515 0.951685Z" fill="white"/>
                </svg>
              </button>
            </div>
            
          </div>
          <div className="col-12 col-md-6 col-lg-7">
            <div className="services-div">
              <div className="serv-per-div">
                <svg width="80" height="112" viewBox="0 0 100 132" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M38.6757 97.7625L24.5466 131.084L14.294 121.119L0 120.676L15.3448 84.4934L15.7005 85.2177C16.5382 86.9262 17.7782 88.4059 19.314 89.5294C20.8498 90.653 22.6354 91.3868 24.5175 91.6679L31.6499 92.7316L37.4729 96.9898C37.8587 97.2702 38.2603 97.5282 38.6757 97.7625Z" fill="#1036CE"/>
                  <path d="M99.9998 120.676L85.7058 121.119L75.4533 131.084L61.0493 97.1159L62.223 97.2905C64.1048 97.5712 66.0266 97.3907 67.8232 96.7644C69.6198 96.1381 71.2374 95.0849 72.5369 93.6951L77.4676 88.4282L84.28 86.0551C84.5839 85.9484 84.8781 85.832 85.1691 85.7026L99.9998 120.676Z" fill="#1036CE"/>
                  <path d="M66.5281 42.0043L55.2422 41.186L50.9809 30.6871C50.8994 30.4851 50.7584 30.3126 50.5767 30.1925C50.395 30.0723 50.1811 30.0102 49.9633 30.0144C49.7513 30.0127 49.5438 30.0757 49.3686 30.195C49.1933 30.3142 49.0585 30.4841 48.9822 30.6818L44.7187 41.186L33.4287 42.0046C33.2154 42.0152 33.0104 42.0909 32.8413 42.2215C32.6722 42.3521 32.5473 42.5314 32.4832 42.7352C32.4132 42.9399 32.4076 43.1612 32.4672 43.3691C32.5268 43.5771 32.6487 43.7618 32.8165 43.8984L41.4791 51.2067L38.7704 62.2121C38.7146 62.4233 38.7248 62.6465 38.7994 62.8518C38.8741 63.0571 39.0097 63.2347 39.1881 63.3608C39.3595 63.4877 39.5656 63.5593 39.7788 63.566C39.992 63.5728 40.2021 63.5143 40.3812 63.3985L50.0085 57.4132L59.6323 63.425C59.8159 63.5333 60.0273 63.5852 60.2401 63.5744C60.453 63.5636 60.658 63.4905 60.8296 63.3641C61.0013 63.2378 61.132 63.0638 61.2056 62.8637C61.2792 62.6637 61.2924 62.4465 61.2435 62.239L58.5344 51.2332L67.1978 43.9246C67.3614 43.7859 67.4794 43.6011 67.5363 43.3943C67.5932 43.1875 67.5863 42.9683 67.5166 42.7654C67.4483 42.5534 67.3172 42.3671 67.1407 42.2311C66.9642 42.0952 66.7505 42.0161 66.5281 42.0043Z" fill="#1036CE"/>
                  <path d="M95.2102 34.2887L89.6794 27.6925L87.8477 19.2816C87.6378 18.3176 87.1969 17.419 86.563 16.663C85.9291 15.907 85.1212 15.3162 84.2085 14.9413L76.2459 11.671L70.7153 5.07468C70.0814 4.31867 69.2735 3.72788 68.3608 3.35306C67.4482 2.97823 66.4582 2.83059 65.476 2.92282L56.9056 3.72736L48.9431 0.456958C48.0304 0.0821206 47.0405 -0.0655353 46.0582 0.0266782C45.0759 0.118892 44.1307 0.448217 43.3038 0.986356L36.089 5.68164L27.5187 6.48627C26.5364 6.57849 25.5912 6.90782 24.7643 7.44596C23.9374 7.9841 23.2535 8.71496 22.7714 9.57574L18.565 17.0861L11.3503 21.7812C10.5234 22.3194 9.83949 23.0502 9.35739 23.911C8.87529 24.7718 8.60939 25.7368 8.58254 26.723L8.34822 35.3279L4.14186 42.8382C3.65976 43.699 3.39386 44.6639 3.367 45.6501C3.34015 46.6364 3.55314 47.6144 3.98768 48.5001L7.7791 56.2283L7.54479 64.8331C7.51793 65.8193 7.73093 66.7973 8.16547 67.6831C8.60002 68.5688 9.24312 69.3358 10.0395 69.9182L16.9881 74.9991L20.7794 82.7272C21.214 83.613 21.8571 84.3799 22.6535 84.9623C23.4499 85.5446 24.3757 85.9249 25.3515 86.0705L33.8654 87.3403L40.8139 92.4212C41.6103 93.0036 42.5362 93.3839 43.512 93.5294C44.4878 93.6749 45.4843 93.5814 46.416 93.2567L54.5447 90.4246L63.0586 91.6943C64.0344 91.8399 65.0309 91.7463 65.9626 91.4217C66.8943 91.0971 67.7332 90.5511 68.4073 89.8307L74.2887 83.5453L82.4175 80.7131C83.3492 80.3885 84.1881 79.8425 84.8622 79.1221C85.5363 78.4018 86.0254 77.5285 86.2875 76.5773L88.5743 68.2786L94.4557 61.9932C95.1298 61.2728 95.6189 60.3995 95.881 59.4483C96.1431 58.4972 96.1704 57.4967 95.9604 56.5327L94.1286 48.1218L96.4154 39.823C96.6775 38.8719 96.7048 37.8713 96.4949 36.9073C96.2849 35.9433 95.8441 35.0447 95.2102 34.2887ZM49.9996 74.6923C44.4827 74.6923 39.0896 73.0563 34.5024 69.9913C29.9152 66.9262 26.3399 62.5697 24.2287 57.4727C22.1174 52.3757 21.565 46.7671 22.6413 41.3561C23.7176 35.9452 26.3743 30.9749 30.2754 27.0738C34.1765 23.1727 39.1468 20.5161 44.5577 19.4398C49.9687 18.3635 55.5773 18.9159 60.6743 21.0271C65.7713 23.1384 70.1278 26.7137 73.1928 31.3008C76.2579 35.888 77.8939 41.2811 77.8939 46.7981C77.8939 50.4612 77.1723 54.0884 75.7705 57.4727C74.3687 60.857 72.314 63.932 69.7238 66.5223C67.1336 69.1125 64.0586 71.1672 60.6743 72.569C57.29 73.9708 53.6627 74.6923 49.9996 74.6923Z" fill="#FF5833"/>
                </svg>
                <p className="fw700 cblack fs30 mb-0 text-end">135k</p>
                <p className="fw500 cgray mb-0 text-end">Lorem Ipsum</p>
              </div>

              <div className="serv-per-div">
                <svg width="85" height="98" viewBox="0 0 105 118" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5899 1.13831L0.255598 18.4019C0.109082 18.6071 0.0219026 18.8487 0.00361624 19.1002C-0.0146701 19.3517 0.036643 19.6034 0.151931 19.8277C0.267218 20.052 0.442029 20.2402 0.657198 20.3717C0.872367 20.5032 1.11959 20.5729 1.37176 20.5732L36.2381 20.6066L50.8504 0H14.8015C14.3689 0.000111665 13.9425 0.10345 13.5579 0.301429C13.1733 0.499409 12.8414 0.786314 12.5899 1.13831Z" fill="#FF5833"/>
                  <path d="M104.307 18.5155L91.8923 1.13831C91.6407 0.786248 91.3086 0.499311 90.9238 0.301333C90.539 0.103355 90.1125 5.03451e-05 89.6798 0H53.6514L68.2194 20.6533L103.188 20.6868C103.44 20.6871 103.688 20.6178 103.904 20.4866C104.119 20.3553 104.295 20.1671 104.41 19.9427C104.526 19.7183 104.578 19.4664 104.559 19.2146C104.541 18.9628 104.454 18.7209 104.307 18.5155Z" fill="#FF5833"/>
                  <path d="M64.5878 24.9379L54.9609 11.2903V53.3198H89.6802C90.615 53.3198 91.5114 52.9484 92.1724 52.2875C92.8334 51.6265 93.2047 50.73 93.2047 49.7953V26.1153L66.8063 26.0899C66.3714 26.089 65.943 25.984 65.557 25.7836C65.1711 25.5831 64.8387 25.2932 64.5878 24.9379Z" fill="#FF5833"/>
                  <path d="M37.6418 26.0465H37.6378L11.2764 26.0681V49.7956C11.2764 50.7303 11.6477 51.6268 12.3087 52.2878C12.9696 52.9488 13.8661 53.3201 14.8009 53.3201H49.5222V11.2725L39.8592 24.8994C39.6079 25.2536 39.2755 25.5425 38.8897 25.7421C38.504 25.9416 38.0761 26.046 37.6418 26.0465Z" fill="#FF5833"/>
                  <path d="M18.497 67.906H5.28899C5.01305 67.906 4.73981 67.9604 4.48488 68.066C4.22995 68.1716 3.99832 68.3264 3.80321 68.5215C3.60811 68.7167 3.45336 68.9483 3.3478 69.2033C3.24224 69.4582 3.18794 69.7315 3.18799 70.0074V115.084C3.18793 115.641 3.40925 116.176 3.80326 116.57C4.19727 116.964 4.7317 117.186 5.28899 117.186H18.497C19.0986 117.186 19.6943 117.067 20.2502 116.837C20.806 116.607 21.3111 116.27 21.7365 115.844C22.1619 115.419 22.4994 114.914 22.7297 114.358C22.9599 113.802 23.0784 113.207 23.0784 112.605V72.4862C23.0784 71.8847 22.9598 71.289 22.7295 70.7332C22.4993 70.1775 22.1618 69.6725 21.7364 69.2472C21.3109 68.8219 20.8059 68.4845 20.2501 68.2544C19.6943 68.0243 19.0986 67.9059 18.497 67.906Z" fill="#1036CE"/>
                  <path d="M101.52 73.1993C100.821 72.1361 99.8695 71.2636 98.7498 70.6602C97.6301 70.0569 96.3778 69.7419 95.1059 69.7435H89.9299C87.7091 69.7389 85.5373 70.396 83.6915 71.631C81.8458 72.866 80.4098 74.6229 79.5669 76.6775C79.0667 77.8721 78.3696 78.9745 77.5047 79.9385C76.0345 82.1957 74.0453 84.068 71.7034 85.399C69.3615 86.7301 66.735 87.4811 64.0434 87.5893L48.7122 87.5903C47.9911 87.5903 47.2996 87.3038 46.7897 86.7939C46.2798 86.2841 45.9933 85.5925 45.9933 84.8714C45.9933 84.1503 46.2798 83.4587 46.7897 82.9489C47.2996 82.439 47.9911 82.1525 48.7122 82.1525H63.9707C65.9311 82.1022 67.8357 81.4894 69.4576 80.387V80.2948C69.4629 78.9112 69.195 77.5402 68.6692 76.2603C68.1435 74.9805 67.3702 73.8171 66.3938 72.8368C65.4174 71.8565 64.257 71.0786 62.9793 70.5478C61.7015 70.017 60.3316 69.7436 58.948 69.7435H47.6978C45.642 69.7377 43.6054 70.1388 41.7053 70.9236C39.8053 71.7085 38.0793 72.8616 36.6269 74.3164L36.3397 74.6024C34.2111 76.7279 31.4778 78.1437 28.5137 78.656V108.687H69.5416C75.6247 108.691 81.5752 106.909 86.6553 103.563C91.7354 100.217 95.7218 95.4533 98.1202 89.8629L102.162 80.4557C102.666 79.288 102.871 78.0131 102.759 76.7462C102.647 75.4793 102.221 74.2603 101.52 73.1993Z" fill="#1036CE"/>
                </svg>
                <p className="fw700 cblack fs30 mb-0 text-end">10k</p>
                <p className="fw500 cgray mb-0 text-end">Lorem Ipsum</p>
              </div>

              <div className="serv-per-div">
                <svg width="96" height="96" viewBox="0 0 116 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M115.518 50.386C115.365 49.3406 114.839 48.3858 114.038 47.6976C113.236 47.0094 112.212 46.6343 111.156 46.6413H102.819L102.318 44.8902C101.362 41.7806 100.121 38.7659 98.6109 35.8844L97.8321 34.3244L103.518 28.6389C104.276 27.8798 104.732 26.8711 104.802 25.8005C104.872 24.7299 104.551 23.6703 103.898 22.8189C100.799 18.8104 97.1878 15.226 93.1559 12.1576C92.3042 11.5003 91.2428 11.1749 90.169 11.2419C89.0953 11.3089 88.0825 11.7638 87.3192 12.5219L81.5906 18.2505L79.9811 17.3112C77.1507 15.7742 74.1599 14.553 71.0626 13.6697L69.3563 13.1458V4.94628C69.3548 3.88733 68.9733 2.86408 68.2812 2.06258C67.5892 1.26107 66.6325 0.734515 65.585 0.578648C63.0741 0.201773 60.539 0.00857575 58 0.000594279C55.4541 -0.0110944 52.9102 0.149654 50.386 0.481736C49.3406 0.634845 48.3858 1.16074 47.6976 1.96245C47.0094 2.76416 46.6342 3.78764 46.6413 4.8442V13.1836L44.8878 13.6839C41.778 14.6395 38.7626 15.879 35.8797 17.3867L34.3221 18.1655L28.6362 12.4813C27.8771 11.7233 26.8685 11.2669 25.7981 11.1969C24.7277 11.1269 23.6682 11.4481 22.8169 12.1008C18.8075 15.199 15.223 18.811 12.1556 22.8441C11.4988 23.6958 11.1737 24.7571 11.2409 25.8305C11.3081 26.904 11.7629 27.9165 12.5208 28.6796L18.2505 34.4094L17.3112 36.0189C15.7757 38.8495 14.5539 41.8393 13.6674 44.935L13.1411 46.6413H4.94597C3.88675 46.6429 2.86329 47.0246 2.0617 47.717C1.26012 48.4094 0.733655 49.3665 0.578052 50.4142C0.201838 52.9255 0.00883857 55.4608 0.000582749 58C-0.010976 60.5455 0.149426 63.0888 0.480695 65.6126C0.633513 66.6583 1.1593 67.6135 1.96107 68.3019C2.76285 68.9904 3.78653 69.3657 4.8433 69.3587H13.1788L13.6792 71.1098C14.6354 74.2194 15.8765 77.2341 17.3867 80.1156L18.1655 81.6756L12.4801 87.3609C11.7219 88.12 11.2653 89.1287 11.1952 90.1993C11.1252 91.27 11.4465 92.3296 12.0993 93.181C15.1982 97.1895 18.8098 100.774 22.8417 103.842C23.6934 104.5 24.7549 104.825 25.8286 104.758C26.9023 104.691 27.9151 104.236 28.6784 103.478L34.407 97.7495L36.0165 98.6888C38.8475 100.225 41.8381 101.446 44.935 102.33L46.6413 102.854V111.054C46.6428 112.113 47.0243 113.136 47.7163 113.937C48.4084 114.739 49.3651 115.265 50.4125 115.421C52.9243 115.798 55.4601 115.992 58 115.999C60.5452 116.011 63.0882 115.85 65.6116 115.518C66.657 115.365 67.6118 114.839 68.3 114.037C68.9882 113.236 69.3634 112.212 69.3563 111.156V102.816L71.1098 102.316C74.2196 101.36 77.235 100.121 80.1179 98.6133L81.6755 97.8345L87.3614 103.519C88.1205 104.277 89.1291 104.733 90.1996 104.803C91.27 104.873 92.3294 104.552 93.1807 103.899C97.1901 100.801 100.775 97.1889 103.842 93.1559C104.499 92.3042 104.824 91.2429 104.757 90.1694C104.69 89.0959 104.235 88.0834 103.477 87.3203L97.7472 81.5906L98.6865 79.9811C100.222 77.1505 101.444 74.1608 102.33 71.065L102.857 69.3587H111.053C112.112 69.357 113.135 68.9754 113.937 68.2831C114.738 67.5909 115.265 66.6339 115.42 65.5864C115.798 63.075 115.991 60.5395 115.999 58C116.011 55.4541 115.85 52.9103 115.518 50.386ZM58 90.0565C51.6598 90.0565 45.462 88.1765 40.1903 84.654C34.9186 81.1316 30.8098 76.1251 28.3835 70.2675C25.9572 64.4099 25.3224 57.9644 26.5593 51.746C27.7962 45.5276 30.8493 39.8157 35.3325 35.3325C39.8157 30.8493 45.5276 27.7962 51.746 26.5593C57.9644 25.3224 64.4099 25.9572 70.2675 28.3835C76.1251 30.8098 81.1316 34.9186 84.654 40.1903C88.1764 45.462 90.0565 51.6598 90.0565 58C90.0565 66.5019 86.6791 74.6556 80.6674 80.6674C74.6556 86.6791 66.5019 90.0565 58 90.0565Z" fill="#1036CE"/>
                  <path d="M78.8322 65.2479L67.4257 62.2029L58.4841 68.7279L49.7841 62.2029L37.6285 65.2721C36.9968 65.4419 36.4239 65.7818 35.9722 66.2548C35.5205 66.7278 35.2073 67.3158 35.0668 67.9545L34.4868 72.2803C36.962 76.3654 40.459 79.735 44.6331 82.057C48.8071 84.379 53.5142 85.5732 58.2904 85.522C63.0666 85.4708 67.747 84.1759 71.8703 81.7649C75.9936 79.3539 79.4175 75.9101 81.8046 71.7729L81.3696 68.0029C81.2522 67.35 80.9512 66.7441 80.5018 66.2562C80.0524 65.7682 79.4733 65.4184 78.8322 65.2479Z" fill="#FF5833"/>
                  <path d="M56.7279 59.096C57.1393 59.1222 59.0937 59.13 59.6101 59.0634C65.3689 58.3197 68.562 48.2124 68.562 42.8591C68.562 40.0579 67.4492 37.3713 65.4684 35.3905C63.4876 33.4097 60.8011 32.2969 57.9998 32.2969C55.1985 32.2969 52.5119 33.4097 50.5311 35.3905C48.5503 37.3713 47.4375 40.0579 47.4375 42.8591C47.4375 48.3162 50.7558 58.714 56.7279 59.096Z" fill="#FF5833"/>
                </svg>
                <p className="fw700 cblack fs30 mb-0 text-end">230+</p>
                <p className="fw500 cgray mb-0 text-end">Lorem Ipsum</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}


      {/* <div className="services-provided-div">
        <div className="container main-wrap">
          <div className="row mb-5">
            <div className="col-12 position-relative">

            <div className="swiper-serpro">
              <Swiper
                breakpoints={{
                // when window width is >= 320px
                320: {
                  spaceBetween: 10,
                  slidesPerView: 2,
                },
                // when window width is >= 640px
                640: {
                  spaceBetween: 10,
                  slidesPerView: 3,
                },
                // when window width is >= 768px
                768: {
                  spaceBetween: 100,
                  slidesPerView: 5,
                },
              }}
                
                // slidesPerView={5}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
                navigation={{
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current,
                }}
                modules={[Navigation]}
              >
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Accessories</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Bicycles</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Clothes</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Event Venues</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Offices</p>
                </SwiperSlide>

                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Accessories</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Bicycles</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Clothes</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Event Venues</p>
                </SwiperSlide>
                <SwiperSlide>
                  <p className="mb-0 fw700 cwhite fs20">Offices</p>
                </SwiperSlide>
              </Swiper>
            </div>


            <div ref={navigationPrevRef} className="ser-pro-swiper-back">
              
              <svg width="15" height="12" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M9.24814 16.4337C9.02311 16.6586 8.71794 16.785 8.39974 16.785C8.08155 16.785 7.77638 16.6586 7.55134 16.4337L0.351344 9.23365C0.126378 9.00862 0 8.70345 0 8.38525C0 8.06706 0.126378 7.76189 0.351344 7.53685L7.55134 0.336854C7.77767 0.118264 8.08079 -0.00268874 8.39542 4.53632e-05C8.71006 0.00277947 9.01104 0.128982 9.23353 0.351472C9.45601 0.573962 9.58222 0.874936 9.58495 1.18957C9.58769 1.50421 9.46673 1.80733 9.24814 2.03365L4.09654 7.18525H17.9997C18.318 7.18525 18.6232 7.31168 18.8483 7.53673C19.0733 7.76177 19.1997 8.06699 19.1997 8.38525C19.1997 8.70351 19.0733 9.00874 18.8483 9.23378C18.6232 9.45883 18.318 9.58525 17.9997 9.58525H4.09654L9.24814 14.7369C9.47311 14.9619 9.59949 15.2671 9.59949 15.5853C9.59949 15.9035 9.47311 16.2086 9.24814 16.4337Z" fill="white"/>
              </svg>

            </div>
            <div ref={navigationNextRef} className="ser-pro-swiper-next">
              
              <svg width="15" height="12" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M10.7519 16.4337C10.9769 16.6586 11.2821 16.785 11.6003 16.785C11.9185 16.785 12.2236 16.6586 12.4487 16.4337L19.6487 9.23365C19.8736 9.00862 20 8.70345 20 8.38525C20 8.06706 19.8736 7.76189 19.6487 7.53685L12.4487 0.336854C12.2223 0.118264 11.9192 -0.00268874 11.6046 4.53632e-05C11.2899 0.00277947 10.989 0.128982 10.7665 0.351472C10.544 0.573962 10.4178 0.874936 10.415 1.18957C10.4123 1.50421 10.5333 1.80733 10.7519 2.03365L15.9035 7.18525H2.00026C1.682 7.18525 1.37677 7.31168 1.15173 7.53673C0.926685 7.76177 0.800257 8.06699 0.800257 8.38525C0.800257 8.70351 0.926685 9.00874 1.15173 9.23378C1.37677 9.45883 1.682 9.58525 2.00026 9.58525H15.9035L10.7519 14.7369C10.5269 14.9619 10.4005 15.2671 10.4005 15.5853C10.4005 15.9035 10.5269 16.2086 10.7519 16.4337Z" fill="white"/>
              </svg>

            </div>

            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-12 col-lg-6">
              <img src="assets/images/accessories.png" className="img-fluid" />
            </div>
            <div className="col-12 col-md-12 col-lg-6">
              <div className="ser-pro-desc-div">
                <h3 className="mb-4 fw700 cwhite">Accessories</h3>
                <p className="mb-5 fw500 cwhite">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Donec volutpat, arcu sit amet malesuada convallis, nisi nibh placerat nulla, vitae interdum leo nibh convallis nisi. Sed ac felis ac velit tristique consequat non ut purus. Etiam pulvinar aliquam ante, venenatis condimentum massa malesuada et. Proin neque lacus, malesuada non felis ut, malesuada auctor turpis. Cras ut tortor vel quam finibus viverra. Praesent mattis mollis dui, quis faucibus magna scelerisque in. Morbi at erat aliquet, cursus nunc ac, fringilla lacus.</p>
                <a href="/leases" className="btn btn-orang-def">Explore Now</a>
              </div>

            </div>
          </div>
        </div>
      </div> */}

      {/* if lessor */}
      {me && me.role.id == 3 ? (
        <div className="container-fluid feat-content">
          <div className="container main-wrap feat-div">
            <div className="row">
            

            {!productsLoading ?
              userProducts && userProducts.data.length !== 0 ? (
              <>
                {userProducts.data.map((post, index) => {
                  return (
                    <div key={index} className="col-12 col-lg-4">
                      <div className="prod-list-single-div-lessor">
                        <div className="prod-img-div position-relative">
                          <img src={`${post.post_images.length !== 0 ? post.post_images[0].image : 'assets/images/prod1.png'}`} className="imgenclose" 
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src="assets/images/prod1.png";
                            }}
                          />
                          <span className="generateqr-icon-div" onClick={() => onGenerateQr(post)}>
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                              <path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M4 4h6v6H4V4Zm10 10h6v6h-6v-6Zm0-10h6v6h-6V4Zm-4 10h.01v.01H10V14Zm0 4h.01v.01H10V18Zm-3 2h.01v.01H7V20Zm0-4h.01v.01H7V16Zm-3 2h.01v.01H4V18Zm0-4h.01v.01H4V14Z"/>
                              <path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01v.01H7V7Zm10 10h.01v.01H17V17Z"/>
                            </svg>
                          </span>
                          
                          <span className="delete-icon-div" onClick={() => onDeletePost(post)}>
                            <svg width="20" height="22" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M10.3998 0.200012C10.1027 0.200171 9.8116 0.283025 9.55896 0.439296C9.30633 0.595567 9.10219 0.819083 8.96941 1.08481L7.81101 3.40001H2.3998C1.97546 3.40001 1.56849 3.56858 1.26843 3.86864C0.968376 4.1687 0.799805 4.57567 0.799805 5.00001C0.799805 5.42436 0.968376 5.83132 1.26843 6.13138C1.56849 6.43144 1.97546 6.60001 2.3998 6.60001V22.6C2.3998 23.4487 2.73695 24.2626 3.33706 24.8628C3.93718 25.4629 4.75111 25.8 5.5998 25.8H18.3998C19.2485 25.8 20.0624 25.4629 20.6625 24.8628C21.2627 24.2626 21.5998 23.4487 21.5998 22.6V6.60001C22.0242 6.60001 22.4311 6.43144 22.7312 6.13138C23.0312 5.83132 23.1998 5.42436 23.1998 5.00001C23.1998 4.57567 23.0312 4.1687 22.7312 3.86864C22.4311 3.56858 22.0242 3.40001 21.5998 3.40001H16.1886L15.0302 1.08481C14.8974 0.819083 14.6933 0.595567 14.4406 0.439296C14.188 0.283025 13.8969 0.200171 13.5998 0.200012H10.3998ZM7.19981 9.80001C7.19981 9.37567 7.36838 8.9687 7.66843 8.66864C7.96849 8.36858 8.37546 8.20001 8.79981 8.20001C9.22415 8.20001 9.63112 8.36858 9.93118 8.66864C10.2312 8.9687 10.3998 9.37567 10.3998 9.80001V19.4C10.3998 19.8244 10.2312 20.2313 9.93118 20.5314C9.63112 20.8314 9.22415 21 8.79981 21C8.37546 21 7.96849 20.8314 7.66843 20.5314C7.36838 20.2313 7.19981 19.8244 7.19981 19.4V9.80001ZM15.1998 8.20001C14.7755 8.20001 14.3685 8.36858 14.0684 8.66864C13.7684 8.9687 13.5998 9.37567 13.5998 9.80001V19.4C13.5998 19.8244 13.7684 20.2313 14.0684 20.5314C14.3685 20.8314 14.7755 21 15.1998 21C15.6242 21 16.0311 20.8314 16.3312 20.5314C16.6312 20.2313 16.7998 19.8244 16.7998 19.4V9.80001C16.7998 9.37567 16.6312 8.9687 16.3312 8.66864C16.0311 8.36858 15.6242 8.20001 15.1998 8.20001Z" fill="#FF0000"/>
                            </svg>
                          </span>

                          <span className="edit-icon-div" onClick={() => onEditPost(post)}>
                            <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.8626 4.13772C27.2625 3.53782 26.4487 3.20081 25.6002 3.20081C24.7517 3.20081 23.9379 3.53782 23.3378 4.13772L11.2002 16.2753V20.8001H15.725L27.8626 8.66252C28.4625 8.06243 28.7995 7.24865 28.7995 6.40012C28.7995 5.5516 28.4625 4.73781 27.8626 4.13772Z" fill="white"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M3.2002 9.60002C3.2002 8.75133 3.53734 7.9374 4.13745 7.33728C4.73757 6.73717 5.5515 6.40002 6.4002 6.40002H12.8002C13.2245 6.40002 13.6315 6.5686 13.9316 6.86865C14.2316 7.16871 14.4002 7.57568 14.4002 8.00002C14.4002 8.42437 14.2316 8.83134 13.9316 9.1314C13.6315 9.43145 13.2245 9.60002 12.8002 9.60002H6.4002V25.6H22.4002V19.2C22.4002 18.7757 22.5688 18.3687 22.8688 18.0687C23.1689 17.7686 23.5758 17.6 24.0002 17.6C24.4245 17.6 24.8315 17.7686 25.1316 18.0687C25.4316 18.3687 25.6002 18.7757 25.6002 19.2V25.6C25.6002 26.4487 25.2631 27.2626 24.6629 27.8628C24.0628 28.4629 23.2489 28.8 22.4002 28.8H6.4002C5.5515 28.8 4.73757 28.4629 4.13745 27.8628C3.53734 27.2626 3.2002 26.4487 3.2002 25.6V9.60002Z" fill="white"/>
                            </svg>
                          </span>

                        </div>
                        <div className="prod-upper-text-div">
                          <p className="cblack fs18 mb-2">
                            <a href="#" className="cblack">{post.title}</a>
                          </p>
                          <div>
                            <p className="fw500 cblack mb-0 fs12">
                              <svg width="18" height="17" style={{marginRight:"8px", marginTop:"-4px"}} viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.0491 0.927078C9.3491 0.00607812 10.6521 0.00607812 10.9511 0.927078L12.4701 5.60108C12.5355 5.80157 12.6625 5.97626 12.8332 6.10018C13.0038 6.22411 13.2092 6.29092 13.4201 6.29108H18.3351C19.3041 6.29108 19.7061 7.53108 18.9231 8.10108L14.9471 10.9891C14.7763 11.1132 14.6492 11.2883 14.584 11.4891C14.5188 11.6899 14.5188 11.9063 14.5841 12.1071L16.1021 16.7811C16.4021 17.7031 15.3471 18.4691 14.5641 17.8991L10.5881 15.0111C10.4172 14.8869 10.2114 14.8199 10.0001 14.8199C9.78883 14.8199 9.58298 14.8869 9.4121 15.0111L5.4361 17.8991C4.6531 18.4691 3.5981 17.7021 3.8981 16.7811L5.4161 12.1071C5.48137 11.9063 5.48141 11.6899 5.4162 11.4891C5.351 11.2883 5.22389 11.1132 5.0531 10.9891L1.0771 8.10108C0.293095 7.53108 0.697095 6.29108 1.6651 6.29108H6.5791C6.79014 6.29113 6.9958 6.22442 7.16662 6.10048C7.33744 5.97654 7.46467 5.80173 7.5301 5.60108L9.0491 0.927078Z" fill="#FFBF05"/>
                              </svg>
                              {post.review_average}
                            </p>
                            <p className="cgray fs12 mb-0">({post.review_count} reviews)</p>
                          </div>
                        </div>
                        <div className="d-flex mb-2">
                          {post.post_lease_terms.map((term, index) => (
                            <div key={index} className="price fw800 cveryblack text-truncate" style={{marginRight: intl.locale ==="en" ? "10px" : "0px", marginLeft: intl.locale === "en" ? "0px" : "10px"}}>{`SR ${term.price}`} <span className="fw500">/ {term.lease_term === "fixed" && `${term?.period}`} {translateTerm(term.lease_term)} {term.lease_term === "fixed" && (term.period_type === "daily" ? intl.locale === "en" ? `Days` : "أيام" : intl.locale === "en" ? "Hours" : "ساعات")}</span></div>
                          ))}
                        </div>
                        
                        <div className="cgray fs14 text-truncate">
                          <svg width="18" height="21" style={{marginRight: intl.locale ==="en" ? "5px" : "0px", marginLeft: intl.locale === "en" ? "0px" : "5px"}} viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M3.06022 2.85984C4.6356 1.28446 6.77228 0.399414 9.00021 0.399414C11.2281 0.399414 13.3648 1.28446 14.9402 2.85984C16.5156 4.43523 17.4006 6.57191 17.4006 8.79984C17.4006 11.0278 16.5156 13.1645 14.9402 14.7398L9.00021 20.6798L3.06022 14.7398C2.28011 13.9598 1.6613 13.0338 1.2391 12.0146C0.81691 10.9954 0.599609 9.90302 0.599609 8.79984C0.599609 7.69667 0.81691 6.6043 1.2391 5.5851C1.6613 4.56591 2.28011 3.63987 3.06022 2.85984ZM9.00021 11.1998C9.63673 11.1998 10.2472 10.947 10.6973 10.4969C11.1474 10.0468 11.4002 9.43636 11.4002 8.79984C11.4002 8.16332 11.1474 7.55287 10.6973 7.10279C10.2472 6.6527 9.63673 6.39984 9.00021 6.39984C8.3637 6.39984 7.75325 6.6527 7.30316 7.10279C6.85307 7.55287 6.60021 8.16332 6.60021 8.79984C6.60021 9.43636 6.85307 10.0468 7.30316 10.4969C7.75325 10.947 8.3637 11.1998 9.00021 11.1998Z" fill="#AAAAAA"/>
                          </svg>
                          {/* {console.log(post)} */}
                          {/* {post.area && intl.locale === "en" ? post.area.en : post.area.ar}, {post.city && intl.locale === "en" ? post.city.en : post.city.ar} */}
                          {post?.location}
                        </div>
                      </div>
                    </div>
                  )
                })}
                {moreLoading &&  
                    <div className="loader"></div>
                }
                {noMorePosts && userProducts && 
                  <div className="nomoreposts d-flex justify-content-center">
                      <span className="cgray fs12">
                          <FormattedMessage 
                              id="nomoreposts.text"
                              defaultMessage="No more available posts"
                              description="No more available posts"
                          />
                      </span>
                  </div>
                }
                {/* {toTop &&
                    <div className="nomoreposts d-flex justify-content-end mt-2" onClick={setMeToTop}>
                        <div className="bg-primary p-1 rounded-pill cursorPointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 15l-6-6-6 6"/></svg>
                        </div>
                    </div>
                } */}

                <div className="d-flex justify-content-center mt-5">
                  <div>
                    <div className="text-center">
                      <button className="btn btn-orang-def" onClick={onClickAddPost}>
                        <FormattedMessage 
                          id="addpost2.text"
                          defaultMessage="Add post"
                          description="Add post"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </>
              )
              
              : (
                // when no post
                <div className="d-flex justify-content-center mt-5">
                  <div>
                    <div className="text-center">
                      <img src="assets/images/no-lease-img.png" className="img-fluid pt-5 mb-4" />
                      <p className="fs30 fw700 cgray">
                        <FormattedMessage 
                          id="youhavenopost.text"
                          defaultMessage="You have no Post Yet"
                          description="You have no Post Yet"
                        />
                      </p>

                      <button className="btn btn-orang-def" onClick={onClickAddPost}>
                        <FormattedMessage 
                          id="addpost2.text"
                          defaultMessage="Add post"
                          description="Add post"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                // when no post
              ) : (
              <div className="loader"></div>
            )}
            
            </div>
          </div>
          
        <div ref={elementRef}></div>
        </div>
      ) : (
        <div className="container-fluid feat-content">
          {/* <div className="container main-wrap feat-div">
            <div className="row">
              <div className="col-12 mb-5">
                <h3 className="fw700 cblack mb-2 text-center">
                  <FormattedMessage 
                    id="featuredleases.text"
                    defaultMessage="Featured Leases"
                    description="Featured Leases"
                  />
                </h3>
                <p className="fw400 cblack mb-0 text-center">
                  <FormattedMessage 
                    id="featuredleasesdesc.text"
                    defaultMessage="Featured Leases desc"
                    description="Featured Leases desc"
                  />
                </p>
              </div>
            </div>

            <div className="row">
              {!productsLoading ? userProducts && 
                userProducts.data.map((pt) => (
                  <div className="col-12 col-lg-4 cur-pointer" onClick={() => onClickPost(pt.id)}>
                    <div className="prod-list-single-div">
                      <div className="prod-img-div">
                        <img src={pt.post_images.length !== 0 ? pt.post_images[0].image : "assets/images/prod1.png"} className="imgenclose" />
                      </div>
                      <div className="prod-upper-text-div">
                        {pt.post_lease_terms.map((term) => (
                          <p className="price fw800 cveryblack">SR {term.price} <span className="fw500">/{translateTerm(term.lease_term)}</span></p>
                        ))}
                        <div>
                          <p className="fw500 cblack mb-0 fs12">
                            <svg width="18" height="17" style={{marginRight:"8px", marginTop:"-4px"}} viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9.0491 0.927078C9.3491 0.00607812 10.6521 0.00607812 10.9511 0.927078L12.4701 5.60108C12.5355 5.80157 12.6625 5.97626 12.8332 6.10018C13.0038 6.22411 13.2092 6.29092 13.4201 6.29108H18.3351C19.3041 6.29108 19.7061 7.53108 18.9231 8.10108L14.9471 10.9891C14.7763 11.1132 14.6492 11.2883 14.584 11.4891C14.5188 11.6899 14.5188 11.9063 14.5841 12.1071L16.1021 16.7811C16.4021 17.7031 15.3471 18.4691 14.5641 17.8991L10.5881 15.0111C10.4172 14.8869 10.2114 14.8199 10.0001 14.8199C9.78883 14.8199 9.58298 14.8869 9.4121 15.0111L5.4361 17.8991C4.6531 18.4691 3.5981 17.7021 3.8981 16.7811L5.4161 12.1071C5.48137 11.9063 5.48141 11.6899 5.4162 11.4891C5.351 11.2883 5.22389 11.1132 5.0531 10.9891L1.0771 8.10108C0.293095 7.53108 0.697095 6.29108 1.6651 6.29108H6.5791C6.79014 6.29113 6.9958 6.22442 7.16662 6.10048C7.33744 5.97654 7.46467 5.80173 7.5301 5.60108L9.0491 0.927078Z" fill="#FCE412"/>
                            </svg>
                            {pt.review_average}
                          </p>
                          <p className="cgray fs12 mb-0">({pt.review_count} <FormattedMessage 
                            id="reviews.text"
                            defaultMessage="Reviews"
                            description="Reviews"
                          />)</p>
                        </div>
                      </div>

                      <p className="cblack fs18 mb-2">
                        <a href="#" className="cblack">{pt.title}</a>
                      </p>
                      <p className="cgray fs14">
                        <svg width="18" height="21" style={{marginRight:"10px", marginLeft:"10px"}} viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M3.06022 2.85984C4.6356 1.28446 6.77228 0.399414 9.00021 0.399414C11.2281 0.399414 13.3648 1.28446 14.9402 2.85984C16.5156 4.43523 17.4006 6.57191 17.4006 8.79984C17.4006 11.0278 16.5156 13.1645 14.9402 14.7398L9.00021 20.6798L3.06022 14.7398C2.28011 13.9598 1.6613 13.0338 1.2391 12.0146C0.81691 10.9954 0.599609 9.90302 0.599609 8.79984C0.599609 7.69667 0.81691 6.6043 1.2391 5.5851C1.6613 4.56591 2.28011 3.63987 3.06022 2.85984ZM9.00021 11.1998C9.63673 11.1998 10.2472 10.947 10.6973 10.4969C11.1474 10.0468 11.4002 9.43636 11.4002 8.79984C11.4002 8.16332 11.1474 7.55287 10.6973 7.10279C10.2472 6.6527 9.63673 6.39984 9.00021 6.39984C8.3637 6.39984 7.75325 6.6527 7.30316 7.10279C6.85307 7.55287 6.60021 8.16332 6.60021 8.79984C6.60021 9.43636 6.85307 10.0468 7.30316 10.4969C7.75325 10.947 8.3637 11.1998 9.00021 11.1998Z" fill="#AAAAAA"/>
                        </svg>
                        {intl.locale === "en" ? pt.area.en : pt.area.ar}
                      </p>
                    </div>
                  </div>
                ))
                : (
                <div class="loader"></div>
              )}
            </div>

            <div className="row">
              <div className="col-12 mb-5">
                <a href="/leases" className="feat-view-more">
                  <FormattedMessage 
                    id="viewmore.text"
                    defaultMessage="View More"
                    description="View More"
                  />
                </a>
              </div>
            </div>
          </div> */}
        </div>
      )}

      <div className="container-fluid hiw-main-content">
        <div className="container main-wrap hiw-main-div">
          <div className="row">
            <div className="col-12 mb-5">
              <h3 className="fw700 cblack mb-0 fs30 text-center">
                <FormattedMessage 
                  id="howwork.text"
                  defaultMessage="How It Works"
                  description="How It Works"
                />
              </h3>
            </div>
          </div>

          <div className="row text-center">
            <div className="col-12 col-lg-4">
              <div className="position-relative mb-5 mt-5 hiw-outer-div">
                <div className="d-flex justify-content-center">
                  <div className="hiw-per-top-div">
                    <p className="mb-0 fw700 cwhite fs30">1</p>
                  </div>
                </div>
                <div className="hiw-per-bot-div">
                  <p className="mb-3 fw700 cblack text-uppercase">{me && me.role.id == 3 ? (
                    <FormattedMessage 
                      id="lessorhw1.text"
                      defaultMessage="Step1"
                      description="Step1"
                    />
                  ) : (
                    <FormattedMessage 
                      id="lessehw1.text"
                      defaultMessage="Step1"
                      description="Step1"
                    />
                  )}</p>
                  {/* <p className="mb-0 fw500 cblack">Cras ut tortor vel quam finibus viverra. Praesent mattis mollis dui, quis faucibus magna scelerisque in. Morbi at erat aliquet, </p> */}
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="position-relative mb-5 mt-5 hiw-outer-div">
                <div className="d-flex justify-content-center">
                  <div className="hiw-per-top-div">
                    <p className="mb-0 fw700 cwhite fs30">2</p>
                  </div>
                </div>
                <div className="hiw-per-bot-div">
                  <p className="mb-3 fw700 cblack text-uppercase">{me && me.role.id == 3 ? (
                    <FormattedMessage 
                      id="lessorhw2.text"
                      defaultMessage="Step2"
                      description="Step2"
                    />
                  ) : (
                    <FormattedMessage 
                      id="lessehw2.text"
                      defaultMessage="Step2"
                      description="Step2"
                    />
                  )}</p>
                  {/* <p className="mb-0 fw500 cblack">Cras ut tortor vel quam finibus viverra. Praesent mattis mollis dui, quis faucibus magna scelerisque in. Morbi at erat aliquet, </p> */}
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="position-relative mb-5 mt-5 hiw-outer-div">
                <div className="d-flex justify-content-center">
                  <div className="hiw-per-top-div">
                    <p className="mb-0 fw700 cwhite fs30">3</p>
                  </div>
                </div>
                <div className="hiw-per-bot-div">
                  <p className="mb-3 fw700 cblack text-uppercase">{me && me.role.id == 3 ? (
                    <FormattedMessage 
                      id="lessorhw3.text"
                      defaultMessage="Step3"
                      description="Step3"
                    />
                  ) : (
                    <FormattedMessage 
                      id="lessehw3.text"
                      defaultMessage="Step3"
                      description="Step3"
                    />
                  )}</p>
                  {/* <p className="mb-0 fw500 cblack">Cras ut tortor vel quam finibus viverra. Praesent mattis mollis dui, quis faucibus magna scelerisque in. Morbi at erat aliquet, </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Home);
